export default "__VITE_ASSET__B_EhHVQ0__"